<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { setCssVar } from 'quasar';

declare global {
  interface Window {
    __theme?: string;
  }
}

defineOptions({
  name: 'App',
});
const theme = ref(import.meta.env.VITE_APP_THEME || 'mba');

onMounted(() => {
  window.__theme = theme.value;
  window.dispatchEvent(
    new CustomEvent('theme-changed', {
      detail: {
        storage: theme.value,
      },
    }),
  );
  setQuasarCssVar('primary', '#2882d1', '#E10B1E');
  setQuasarCssVar('menu', '#e5f3ff', 'rgba(225, 11, 30, 0.1)');
});
function setQuasarCssVar(key: string, color1: string, color2: string) {
  setCssVar(key, theme.value === 'mba' ? color1 : color2);
}
</script>
